<!-- eslint-disable vue/no-v-html -->
<template>
    <div v-html="field.htmlContent" />
</template>

<script setup>
defineProps({
    field: {
        type: Object,
        required: true,
    }
});
</script>
